export default __webpack_public_path__ + "static/public-safety-hero-23d97ca7cab4e95495dc6034edab2ad2.webp";